import React, { useCallback } from 'react'
import { Field as FormikField, ErrorMessage, FieldInputProps, FormikProps } from 'formik'
import { TextField } from 'formik-material-ui'
import styled from 'styled-components'
import { FieldT } from './types'

interface Props {
  field: FieldT
}

const StyledField = styled(FormikField)`
  max-width: 800px;
`

const DateTimeField: React.FC<Props> = ({ field }) => {
  return (
    <>
      <StyledField key={field.name} name={field.name}>
        {({ field: formikField, form, meta }: { field: FieldInputProps<string>; form: FormikProps<any>; meta: any }) => {
          const handleChange = useCallback(
            (e: React.ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value === '' ? null : e.target.value
              form.setFieldValue(formikField.name, value)
            },
            [form, formikField.name]
          )

          // Convert null to empty string for the input value (React doesn't allow null)
          const fieldWithValue = {
            ...formikField,
            value: formikField.value ?? '',
          }

          return (
            <TextField
              field={fieldWithValue}
              form={form}
              meta={meta}
              label={field.title}
              type='datetime-local'
              variant='outlined'
              fullWidth
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
            />
          )
        }}
      </StyledField>
      <ErrorMessage name={field.name} />
    </>
  )
}

export default DateTimeField
